import { Component, OnInit, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-snackbar-content',
  templateUrl: './custom-snackbar-content.component.html',
  styleUrls: ['./custom-snackbar-content.component.scss']
})
export class CustomSnackbarContentComponent implements OnInit {

  constructor(public snackBarRef: MatSnackBarRef<CustomSnackbarContentComponent>,
              @Inject(MAT_SNACK_BAR_DATA) public data: any) { }

  ngOnInit(): void {
  }

}
